<template>
  <van-action-sheet v-model="show_ratechecking" :round="false">
    <div class="rate-checking-content" v-if="easypacel">
      <div class="ratechecking-list" v-for="(item, index) in easypacel" :key="index" @click="chooseRateChecking(item)">
        <div class="flex flex-center justify-center">
          <img class="rate-logo" :src="item.courier_logo" />
          <div>
            <div class="rate-name">{{item.courier_name}}</div>
            <div class="rate-delivery">{{item.delivery}}</div>
          </div>
          <div class="rate-price">RM {{item.price}}</div>
        </div>
      </div>
      <div v-if="ratecheckingLoading" class="ratechecking-loading">
        <van-loading class="loading-icon" type="spinner" color="#1989fa" size="50" />
      </div>
    </div>
  </van-action-sheet>
</template>
<script>
import { updateEasypacelRetechecking } from '@/api/api'
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    easypacel: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      show_ratechecking: false,
      ratecheckingLoading: false
    }
  },
  created () {
    this.show_ratechecking = this.show
  },
  methods: {
    /**
     * 选择物流配送方式
     */
    chooseRateChecking (item) {
      const queryParams = { i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'update_easypacel_retechecking' }
      const actionName = Object.keys(queryParams).map(key => {
        let strVal = queryParams[key]
        return `${key}=${strVal}`
      }).join('&')
      this.ratecheckingLoading = true
      updateEasypacelRetechecking('/app/index.php?' + actionName, { easypacel_ratechecking_shipping: item }).then(res => {
        console.log('保存物流信息成功')
        this.$emit('evtShipType', {})
      }).catch(error => {
        this.$toast('network timeout')
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.rate-checking-content {
  position: relative;
}
.ratechecking-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(255, 255, 255, 80%);
  .loading-icon {
    text-align: center;
    padding-top: 30px;
  }
}
.ratechecking-list {
  padding: 5px 8px;
  div {
    margin: 0 5px;
  }
  .rate-logo {
    width: 60px;
  }
  .rate-name {
    font-size: 14px;
  }
  .rate-delivery {
    font-size: 10px;
  }
  .rate-price {
    font-size: 16px;
    color: chocolate;
    font-weight: bold;
  }
}
</style>